import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "vintageYear",
    "nonVintage",
    "nvBadge",
    "vintageYearContainer",
  ];

  connect() {
    console.log("[vintage-toggle] connect");
    console.log("Targets:", {
      vintageYear: this.hasVintageYearTarget,
      nonVintage: this.hasNonVintageTarget,
      nvBadge: this.hasNvBadgeTarget,
      vintageYearContainer: this.hasVintageYearContainerTarget,
    });
    // If vintage year is -1, check the non-vintage checkbox and show blank
    if (this.vintageYearTarget.value === "-1") {
      this.nonVintageTarget.checked = true;
      this.vintageYearTarget.value = "";
      this.vintageYearTarget.readOnly = true;
      this.vintageYearTarget.classList.add("bg-gray-100", "cursor-not-allowed");
      this.showNvBadge();
    }
    // Don't call toggleVintageField() here as it might interfere with form submission
  }

  toggle() {
    console.log("[vintage-toggle] toggle called");
    this.toggleVintageField();
  }

  toggleVintageField() {
    console.log("[vintage-toggle] toggleVintageField", {
      checked: this.nonVintageTarget.checked,
      vintageYearValue: this.vintageYearTarget.value,
    });
    if (this.nonVintageTarget.checked) {
      // Instead of disabling the field (which prevents submission),
      // we'll set it to -1 and make it read-only
      this.vintageYearTarget.value = "-1";
      this.vintageYearTarget.readOnly = true;
      this.vintageYearTarget.classList.add("bg-gray-100", "cursor-not-allowed");
      this.showNvBadge();
    } else {
      // Only clear the value if it's currently -1 (from non-vintage being checked)
      if (this.vintageYearTarget.value === "-1") {
        this.vintageYearTarget.value = "";
      }
      this.vintageYearTarget.readOnly = false;
      this.vintageYearTarget.classList.remove(
        "bg-gray-100",
        "cursor-not-allowed"
      );
      this.hideNvBadge();
    }
  }

  showNvBadge() {
    console.log("[vintage-toggle] showNvBadge");
    if (this.hasNvBadgeTarget && this.hasVintageYearContainerTarget) {
      this.nvBadgeTarget.classList.remove("hidden");
      this.vintageYearContainerTarget.classList.add("hidden");
    } else {
      console.warn("[vintage-toggle] showNvBadge: missing targets");
    }
  }

  hideNvBadge() {
    console.log("[vintage-toggle] hideNvBadge");
    if (this.hasNvBadgeTarget && this.hasVintageYearContainerTarget) {
      this.nvBadgeTarget.classList.add("hidden");
      this.vintageYearContainerTarget.classList.remove("hidden");
    } else {
      console.warn("[vintage-toggle] hideNvBadge: missing targets");
    }
  }
}
